import { render, staticRenderFns } from "./property-pad-grid.vue?vue&type=template&id=66ed3d9a&"
import script from "./property-pad-grid.vue?vue&type=script&lang=js&"
export * from "./property-pad-grid.vue?vue&type=script&lang=js&"
import style0 from "./property-pad-grid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports